module.exports = __webpack_public_path__ + "img/section.493fb7c4.png";